export const isValorOutros = (valor: unknown) => String(valor) === '99';

export const textoPreenchido = (valor: unknown) => String(valor ?? '').trim().length > 0;

export const formatarMetodoLimpezaOutros = (label: string, outros?: string) =>
	textoPreenchido(outros) ? `Outros (${String(outros).trim()})` : label;

const PREFIXO_OUTROS = /^Outros\s*\((.+)\)\s*$/i;

export const extrairTextoMetodoLimpezaOutros = (metodoLimpeza: string | undefined | null): string | null => {
	if (!metodoLimpeza) {
		return null;
	}

	const match = String(metodoLimpeza).match(PREFIXO_OUTROS);
	return match ? match[1].trim() : null;
};

export const isMetodoLimpezaOutros = (metodoLimpeza: string | undefined | null) =>
	String(metodoLimpeza ?? '').trim().toLowerCase() === 'outros'
	|| extrairTextoMetodoLimpezaOutros(metodoLimpeza) !== null;

export const normalizarMetodoLimpezaParaExibicao = (
	metodoLimpeza: string | undefined | null,
	outros?: string | null,
) => {
	if (extrairTextoMetodoLimpezaOutros(metodoLimpeza)) {
		return metodoLimpeza ?? '';
	}

	if (isValorOutros(metodoLimpeza) || String(metodoLimpeza ?? '').trim().toLowerCase() === 'outros') {
		return formatarMetodoLimpezaOutros('Outros', outros ?? '');
	}

	return metodoLimpeza ?? '';
};
